import { render, staticRenderFns } from "./table_medsos.vue?vue&type=template&id=2ec7aeb4&scoped=true"
import script from "./table_medsos.vue?vue&type=script&lang=js"
export * from "./table_medsos.vue?vue&type=script&lang=js"
import style0 from "./table_medsos.vue?vue&type=style&index=0&id=2ec7aeb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec7aeb4",
  null
  
)

export default component.exports